<i18n>
{
  "cl":{
    "lastInteractionDate": "Última interacción",
    "not-avaliable-data": "No disponible",
    "idNumber": "Rut"
  },
  "pe":{
    "lastInteractionDate": "Última interacción",
    "not-avaliable-data": "No disponible",
    "idNumber": "DNI/CE"
  },
  "br":{
    "lastInteractionDate": "Última interação",
    "not-avaliable-data": "Não disponível",
    "idNumber": "CPF"
  }
}
</i18n>
<template>
  <div class="container">
    <div class="default-item">
      <div
        v-for="prospect in prospectsFromBrokers"
        :key="prospect._id"
        class="card-item shadowless has-text-centered default-item-info med-size-text my-3">
        <span class="default-item-name content-title">
          {{ prospect.name }} {{ prospect.lastName }}
        </span>

        <b-tooltip :label="$t('idNumber')" position="is-left">
          <span class="default-item-idnumber">
            <i class="fa-solid fa-address-card has-text-primary" /> {{ prospect.idNumber || $t("not-avaliable-data") }}
          </span>
        </b-tooltip>

        <b-tooltip :label="$t('lastInteractionDate')" position="is-left" class="mobile-hidden">
          <span
            v-if="prospect.lastInteractionDate"
            class="default-item-date">
            <i class="fas fa-history has-text-primary" />
            {{ formatDate(prospect.lastInteractionDate, "DD/MM/YY HH:mm") }}
          </span>
          <span v-else-if="!prospect.lastInteractionDate && prospect.createdAt" class="default-item-date">
            <i class="fas fa-history has-text-primary" />
            {{ formatDate(prospect.createdAt, "DD/MM/YY HH:mm") }}
          </span>
          <span v-else class="default-item-date">
            <i class="fas fa-history has-text-primary" />
            {{ $t("not-avaliable-data") }}
          </span>
        </b-tooltip>

        <b-tooltip :label="$t('lastInteractionDate')" position="is-bottom" class="interaction-tooltip">
          <span
            v-if="prospect.lastInteractionDate"
            class="default-item-date">
            <i class="fas fa-history has-text-primary" />
            {{ formatDate(prospect.lastInteractionDate, "DD/MM/YY HH:mm") }}
          </span>
          <span v-else-if="!prospect.lastInteractionDate && prospect.createdAt" class="default-item-date">
            <i class="fas fa-history has-text-primary" />
            {{ formatDate(prospect.createdAt, "DD/MM/YY HH:mm") }}
          </span>
          <span v-else class="default-item-date">
            <i class="fas fa-history has-text-primary" />
            {{ $t("not-avaliable-data") }}
          </span>
        </b-tooltip>

        <span class="default-item-stage">
          {{ prospect.status ? $t(`prospectStatus.${prospect.status}`) : "Status" }}
          <br>
          {{ prospect.subStatus ? $t(`prospectSubStatus.${prospect.subStatus}`) : $t("not-avaliable-data") }}
        </span>

        <button
          :id="`prospect-${prospect._id}`"
          class="button manage-button is-button-secondary is-rounded is-fullwidth-mobile"
          @click="goToSingleProspectView(prospect._id)">
          Ver
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToFormatedString } from '@/infrastructure/date';

export default {
  name: 'BrokerLeads',
  props: {
    prospectsFromBrokers: {
      type: Array,
      required: true
    }
  },
  methods: {
    goToSingleProspectView(prospectId) {
      this.$router.push({ path: `/leads/${prospectId}?broker`, replace: true });
    },
    formatDate: (date, format = 'DD/MM/YYYY') => dateToFormatedString(date, format)
  }
};
</script>

<style scoped>
.interaction-tooltip{
    display: none
}
.font-size{
  color:var(--color-nickel);
  font-size: 1.5rem;
  font-weight: 300;
  margin: 10px 0px;
}
.default-item .default-item-info {
  width: 100%;
  display: grid;
  grid:
    "name idnumber date stage button" auto
    / 1fr 1fr 1fr 1fr 1.5fr;
  gap: 0rem 1rem;
  place-items: center;
  place-content: center stretch;
}
.content-title {
  color: var(--primary);
  font-weight: 600;
}
.med-size-text {
  font-size: 0.9rem;
}

@media (max-width: 800px) {
  .med-size-text {
    font-size: 0.8rem;
  }
}
@media (max-width: 650px) {
  .interaction-tooltip{
 display: block;
}
 .mobile-hidden{
    display: none
  }
  .med-size-text {
    font-size: 0.9rem;
  }
  .default-item .default-item-info {
    grid:
      "name" auto
      "date" auto
      "stage" auto
      "button" auto
      / auto;
    place-content: center stretch;
  }
  .button.is-fullwidth-mobile {
    display: flex;
    width: 100%;
  }
}
</style>
